import { MenuItem } from '@card-software/library';
import {
  ClientPurchaseOrderRoles,
  DeliveryNoteRoles,
  IMEXAdminGroup,
  IMEXEditorGroup,
  IMEXViewerGroup,
  OrderReportingRoles,
  PurchaseOrderRoles,
  WorkOrderRoles,
} from './models/roles/roles-group';

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Work Orders',
    routerLink: '/work-orders',
    redirect: false,
    children: [
      {
        displayName: 'Work Orders',
        routerLink: '/work-orders',
        redirect: true,
        roles: [WorkOrderRoles.WorkOrderViewer, WorkOrderRoles.WorkOrderEditor, WorkOrderRoles.WorkOrderAdmin],
      },
      {
        displayName: 'Client Purchase Orders',
        routerLink: '/client-purchase-orders',
        redirect: true,
        roles: [
          ClientPurchaseOrderRoles.ClientPurchaseOrderViewer,
          ClientPurchaseOrderRoles.ClientPurchaseOrderEditor,
          ClientPurchaseOrderRoles.ClientPurchaseOrderAdmin,
        ],
      },
    ],
  },
  {
    displayName: 'Purchase Orders',
    routerLink: '/purchase-orders',
    redirect: false,
    children: [
      {
        displayName: 'Purchase Orders',
        routerLink: '/purchase-orders',
        redirect: true,
        roles: [PurchaseOrderRoles.PurchaseOrderViewer, PurchaseOrderRoles.PurchaseOrderEditor, PurchaseOrderRoles.PurchaseOrderAdmin],
      },
    ],
  },
  {
    displayName: 'Invoices',
    routerLink: '/invoices',
    redirect: false,
    children: [
      {
        displayName: 'Invoices',
        routerLink: '/invoices',
        redirect: true,
        roles: [IMEXViewerGroup.InvoiceViewer, IMEXAdminGroup.InvoiceAdmin],
      },
      {
        displayName: 'Receipts',
        routerLink: '/receipts',
        redirect: true,
        roles: [IMEXViewerGroup.InvoiceViewer, IMEXAdminGroup.InvoiceAdmin],
      },
    ],
  },
  {
    displayName: 'Delivery Notes',
    routerLink: '/delivery-notes',
    redirect: false,
    children: [
      {
        displayName: 'Delivery Notes',
        routerLink: '/delivery-notes',
        redirect: true,
        roles: [DeliveryNoteRoles.DeliveryNoteAdmin],
      },
    ],
  },
  {
    displayName: 'Requisitions',
    routerLink: '/requisitions',
    redirect: false,
    children: [
      {
        displayName: 'Requisitions',
        routerLink: '/requisitions',
        redirect: true,
        roles: [],
      },
    ],
  },
  {
    displayName: 'Shipments',
    routerLink: '/shipments',
    redirect: false,
    children: [
      {
        displayName: 'Shipments',
        routerLink: '/shipments',
        redirect: true,
        roles: [
          IMEXViewerGroup.ShipmentViewer,
          IMEXEditorGroup.ShipmentEditor,
          IMEXAdminGroup.ShipmentAdmin,
          IMEXAdminGroup.ShipmentSupervisor,
        ],
      },
    ],
  },
  {
    displayName: 'Reports',
    routerLink: '/order-reports',
    redirect: false,
    children: [
      {
        displayName: 'Customer Order Reports',
        routerLink: '/order-reports',
        redirect: true,
        roles: [OrderReportingRoles.OrderReportingViewer, OrderReportingRoles.OrderReportingAdmin],
      },
    ],
  },
];
